var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--card-boxes_side-with-image display-grid grid-cols-1 grid-cols-md-10 gap-20 gap-md-30"
  }, [_c('div', {
    class: ['col-span-1 col-span-md-5', {
      'order-md-2 col-start-md-6': _vm.isReverse
    }]
  }, [_c('nuxt-img', {
    staticClass: "w-100 h-auto maxw-445",
    attrs: {
      "src": _vm.imageUrl,
      "alt": _vm.$t(_vm.title),
      "width": "445",
      "height": "445",
      "loading": "lazy"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: ['col-span-1 col-span-md-5 col-span-lg-4 display-flex flex-column justify-content-center align-items-start', {
      'col-start-lg-7': !_vm.isReverse,
      'col-start-md-1 order-md-1': _vm.isReverse
    }]
  }, [_c('h2', {
    staticClass: "typo-h3 typo-md-h1 mb-0"
  }, [_vm._v("\n      " + _vm._s(_vm.$t(_vm.title)) + "\n    ")]), _vm._v(" "), _vm.descriptionElement.length > 0 ? [_c('div', {
    staticClass: "typo-p mt-10 color-text-secondary v-html-content",
    domProps: {
      "innerHTML": _vm._s(_vm.descriptionElement)
    }
  })] : _vm._e(), _vm._v(" "), _vm.$slots.default ? [_vm._t("default")] : _vm._e()], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }